var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeotag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 6.6665C29.7499 6.6665 13.3333 23.0832 13.3333 43.3332C13.3333 67.4465 37.176 78.9929 40.1627 81.6795C43.2127 84.4229 45.728 90.5692 46.7447 94.0558C47.238 95.7492 48.6266 96.6038 49.9999 96.6405C51.3766 96.6005 52.7618 95.7458 53.2551 94.0558C54.2718 90.5692 56.7872 84.4262 59.8372 81.6795C62.8238 78.9929 86.6666 67.4465 86.6666 43.3332C86.6666 23.0832 70.2499 6.6665 49.9999 6.6665ZM49.9999 23.3332C61.0466 23.3332 69.9999 32.2865 69.9999 43.3332C69.9999 54.3798 61.0466 63.3332 49.9999 63.3332C38.9532 63.3332 29.9999 54.3798 29.9999 43.3332C29.9999 32.2865 38.9532 23.3332 49.9999 23.3332ZM49.9999 33.3332C44.4766 33.3332 39.9999 37.8098 39.9999 43.3332C39.9999 48.8565 44.4766 53.3332 49.9999 53.3332C55.5232 53.3332 59.9999 48.8565 59.9999 43.3332C59.9999 42.3165 59.8047 41.356 59.5247 40.436C58.728 42.1427 57.0066 43.3332 54.9999 43.3332C52.2399 43.3332 49.9999 41.0932 49.9999 38.3332C49.9999 36.3265 51.1904 34.6051 52.897 33.8084C51.9771 33.5284 51.0166 33.3332 49.9999 33.3332Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotag);
export default __webpack_public_path__ + "static/media/Geotag.8ab618c844893c9eb699e6b98ce202b0.svg";
export { ForwardRef as ReactComponent };